import React, { useState, useContext } from 'react';
import { HandleDeleteOrganization } from './requests/OrganizationRequests';
import { DataContext } from '../../stores/crm-organization-store';
import GenericDeleteDetailsDropdownModal from './shared/GenericDeleteDetailsDropdownModal';
import { CalculateSettings } from '../crm/shared/Functions';
import { navigate } from 'hookrouter';

const OrganizationsDetailsDropdownModal = () => {
    const [, setShow] = useState(false);

    const {
        store: { activeOrganization, rows, requestObject, viewSettings },
        dispatch,
    } = useContext(DataContext);

    const updateStoreAfterDelete = () => {
        const indexToDelete = rows.findIndex((p) => p.id === activeOrganization.id);
        if (indexToDelete >= 0) {
            rows.splice(indexToDelete, 1);
            requestObject.amount -= 1;
            const newViewSettings = CalculateSettings(viewSettings, requestObject);
            dispatch({ type: 'UPDATE_DATA', payload: rows });
            dispatch({ type: 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT', viewSettings: newViewSettings, requestObject: requestObject });
        }
    };

    const deleteOrganization = async () => {
        const response = await HandleDeleteOrganization(activeOrganization.id);
        if (response.success) {
            setShow(false);
            updateStoreAfterDelete();
            navigate('/crmOrganizations');
            dispatch({
                type: 'UPDATE_ACTIVE_ORGANIZATION',
                payload: response.organization,
            });
        }
        return response;
    };

    return (
        <>
            <GenericDeleteDetailsDropdownModal
                title={activeOrganization.name}
                description='Är du säker på att du vill radera denna organisation?'
                handleDelete={deleteOrganization}
            />
        </>
    );
};
export default OrganizationsDetailsDropdownModal;
